'use strict';

export function showHorseKeepChanges(options) {

    if (!options){
        options = {};
    }

    if (!options.horseID) {
        options.horseID = '';
    }

    var popURL = '/pages/pop/horse/keepRateChange.cfm?'
            + jQuery.param({
                horseID: options.horseID,
            });

    popWin({
        title: 'Horse Keep Rate',
        popID: 'horseKeepChanges',
        page: popURL,
        modal: true,
    });

}

export function showHorseKeepChangesGrid(options) {

    if (!options){
        options = {};
    }

    if (!options.horseID) {
        options.horseID = '';
    }

    if (!options.gridDateFormat) {
        options.gridDateFormat = '';
    }

    var keepRateGridURL = '/components/horse.cfc?' + jQuery.param({
        'method': 'getHorseKeep',
        'jqgrid': 'true',
        'horse_id': options.horseID,
    });

    $('#grid_horse_keep_rate').jqGrid({
        url: keepRateGridURL,
        datatype: 'json',
        autowidth: true,
        height: '100%',
        colNames: [
            'id',
            'Date Effective',
            'Keep Rate Description',
            'Keep Rate ID',
            'Note',
            'KeepRate NominalCode ID',
            'Horse ID',
            'Exclude Admin Fee',
            'Edit',
            'Remove',
        ],
        colModel: [
            {
                name: 'id',
                index: 'id',
                hidden: true,
                editable: false,
            },
            {
                name: 'EffectiveDate',
                index: 'EffectiveDate',
                width: 90,
                editable: false,
                sortable: true,
                search: false,
                date: true,
                sorttype: 'date',
                formatter: 'date',
                formatoptions: {srcformat: 'Y-m-d',
                    newformat: options.gridDateFormat},
            },
            {
                name: 'Description',
                index: 'Description',
                editable: false,
                width: 120,
            },
            {
                name: 'KeepRate_ID',
                index: 'KeepRate_ID',
                hidden: true,
                editable: false,
            },
            {
                name: 'Note',
                index: 'Note',
                hidden: false,
                editable: true,
            },
            {
                name: 'KeepRate_NominalCode_ID',
                index: 'KeepRate_NominalCode_ID',
                hidden: true,
                editable: false,
            },
            {
                name: 'horse_id',
                index: 'horse_id',
                hidden: true,
                editable: false,
            },
            {
                name: 'AdminFee',
                index: 'AdminFee',
                width: 90,
                formatter: 'checkbox',
                align: 'center',
            },
            {
                name: 'edit',
                width: 35,
                align: 'right',
                classes: 'option edit',
                sortable: false,
                resizable: false,
            },
            {
                name: 'remove',
                width: 35,
                align: 'right',
                classes: 'option remove',
                sortable: false,
                resizable: false,
            },
        ],
        rowNum: 5,
        rowList: [5,10,15],
        pager: '#pager10',
        sortable: true,
        sortname: 'EffectiveDate',
        viewrecords: true,
        sortorder: 'desc',
        multiselect: false,
        subGrid: true,
        subGridRowExpanded: function(subGridID, rowID)
        {
            var subGridTableID, pagerID;

            subGridTableID = subGridID + '_t';

            pagerID = 'p_' + subGridTableID;

            var keepRateDesc = $('#grid_horse_keep_rate').jqGrid(
                'getCell',
                rowID,
                'Description',
            );

            var $subGridContents = $('<div>');
            $subGridContents.append(
                $('<div>')
                    .addClass('subgrid-title')
                    .text('Recent Rate History Changes for ' + keepRateDesc)
                    .hide(),
                $('<table>').attr('id', subGridTableID).addClass('scroll'),
                $('<div>').attr('id', pagerID).addClass('scroll'),
            );
            $('#' + subGridID).empty().append($subGridContents);

            // Subgrid URL
            var keepRateId = $('#grid_horse_keep_rate').jqGrid(
                'getCell',
                rowID,
                'KeepRate_ID',
            );

            var subGridURL = '/components/settings.cfc?' + jQuery.param({
                method: 'getKeepRateHistory',
                jqgrid: 'true',
                keeprate_id: keepRateId,
            });

            EQLAPP.COMMON.register({
                'gridID': '#' + subGridTableID,
            });

            //History Grid
            $('#' + subGridTableID).jqGrid({
                url: subGridURL,
                autowidth: true,
                datatype: 'json',
                colNames: [
                    'id',
                    'keepRate_id',
                    'Effective From',
                    'Daily Rate',
                    'Last Updated',
                ],
                colModel: [
                    {
                        name: 'id',
                        index: 'id',
                        hidden: true,
                        editable: false,
                    },
                    {
                        name: 'keepRate_id',
                        index: 'keepRate_id',
                        hidden: true,
                        editable: true,
                    },
                    {
                        name: 'effectiveDate',
                        index: 'effectiveDate',
                        width: 112,
                        align: 'right',
                        date: true,
                        sorttype: 'date',
                        formatter: 'date',
                        formatoptions: {srcformat: 'Y-m-d',
                            newformat: options.gridDateFormat},
                    },
                    {
                        name: 'dailyrate',
                        index: 'dailyrate',
                        width: 85,
                        align: 'right',
                        formatter: 'currency',
                        formatoptions: {decimalPlaces: 2},
                    },
                    {
                        name: 'updatedate',
                        index: 'updatedate',
                        width: 112,
                        align: 'right',
                        sortable: true,
                        search: false,
                        date: true,
                        sorttype: 'date',
                        formatter: 'date',
                        formatoptions: {srcformat: 'Y-m-d',
                            newformat: options.gridDateFormat},
                    },
                ],
                rowNum: 5,
                rowList: [5,10,20],
                sortable: true,
                sortname: 'effectiveDate',
                viewrecords: true,
                sortorder: 'desc',
            }).navGrid({
                search: false,
                add: false,
                edit: false,
                del: false,
                refresh: false,
            });

        },
        loadBeforeSend: function()
        {

        },
        onCellSelect: function(rowid,iCol)
        {
            var cm = $('#grid_horse_keep_rate').jqGrid('getGridParam', 'colModel');
            var colName = cm[iCol].name;

            if (colName == 'edit')
            {
                var ids = '0,' + rowid;
                EQLAPP.KEEPRATE.showHorseKeepChangesEdit({
                    horseID: options.horseID,
                    keepRateID: rowid,
                    newRecord: false,
                });
            }
            else if (colName == 'remove')
            {
                var namedDate = $('#grid_horse_keep_rate').getCell(rowid,'EffectiveDate');
                var horseID = $('#grid_horse_keep_rate').getCell(rowid,'horse_id');
                var ids = rowid + ',' + horseID;
                deleteItem(
                    "Delete the following Keep Rate dated:\n'" + namedDate + "' ?",
                    'horsekeepratehistory',
                    ids,
                    '',
                    false,
                );
            }

        },

    });

    $('#grid_horse_keep_rate').jqGrid('navGrid','#pager10',{
        search: false,
        add: false,
        edit: false,
        del: false,
        refresh: false,
    });

}

export function showHorseKeepChangesEdit(options) {

    if (!options){
        options = {};
    }

    var popupTitle = '';

    if (!options.horseID) {
        options.horseID = '';
    }

    if (!options.newRecord) {
        // Existing Record
        popupTitle = $.i18n('EDIT_HORSE_KEEP_RATE');
        options.newRecord = false;
    } else {
        // New Record
        popupTitle = $.i18n('ADD_HORSE_KEEP_RATE');
        options.newRecord = true;
    }

    if (!options.keepRateID) {
        options.keepRateID = '';
    }

    var popURL = '/pages/pop/horse/keepRateChangeEdit.cfm?' + jQuery.param({
        horseID: options.horseID ,
        newRecord: options.newRecord,
        keepRateID: options.keepRateID,
    });

    popWin({
        title: popupTitle,
        popID: 'horseKeepChangesEdit',
        noAutoWidth: true,
        page: popURL,
        width: 720,
        modal: true,
    });

}

export function keepRateChangeEditDropDownReset(options){

    if (!options.selector){
        EQLAPP.STRIPE.showAlert({
            title: 'Alert',
            body: 'Drop Down Selector Missing'});
        return false;
    };

    if (!options.keepRateID){
        options.keepRateID = '';
    };

    var keepRateURL = '/components/Settings.cfc?' + jQuery.param({
        'method': 'getKeepRateDropDownWeb',
        'activeOnly': 'true',
    });

    var keepRateDropDown = options.selector;

    $.ajax({
        type: 'GET',
        url: keepRateURL,
        data: gen_random(),
        dataType: 'JSON',
        cache: false,
        success: function(data){
            if (data.length > 0){

                // Rebuild dropdown data for Keep Rate Code
                keepRateDropDown.empty();
                // Update DropDown
                var optionElement = document.createElement('option');
                optionElement.value = '';
                optionElement.textContent = '';
                keepRateDropDown.append(optionElement);
                for (var i = 0; i < data.length; i++) {
                    var keepRateID = data[i].keepRateID;
                    var keepRateDescription = data[i].KeepRateDescription;

                    // Create an option element
                    var optionElement = document.createElement('option');
                    optionElement.value = keepRateID;
                    optionElement.textContent = keepRateDescription;

                    // Set the selected attribute if it matches the new Keep Rate batch
                    if (options.keepRateID == keepRateID) {
                        optionElement.selected = true;
                    }

                    // Append the option element to the dropdown
                    keepRateDropDown.append(optionElement);
                }

            } else {
                //No matching records found
            }
        },
        error: function(){
            EQLAPP.STRIPE.showAlert({
                title: 'Alert',
                body: 'Unable to connect to Equisoft Live at this time. Please try again.',
            });
        },
    });

}

export function updateHorseKeepRateDisplay(horseID){

    var updateURL = '/components/horse.cfc?' + jQuery.param({
        'method': 'getHorseCurrentKeepRateDescriptionWeb',
        'horseID': horseID,
    });

    $.ajax({
        type: 'GET',
        url: updateURL,
        dataType: 'json',
        cache: false,
        success: function(data){

            if (data.keepRateDetails.keepRateID > 0){
                var keepRateID = data.keepRateDetails.keepRateID;
                var keepRateDescription = data.keepRateDetails.keepRateDesc;
                var keepRateFee = data.keepRateDetails.keepRateFee;
                var excludeAdminFee =
                    data.keepRateDetails.excludeAdminFee == 1 ? 'true' : 'false';

                updateField(keepRateID,
                    keepRateDescription,
                    'KeepRate_ID',
                    'KeepRate_ID_Display',
                    'true');
                updateField('',keepRateFee,'','KeepRate_Fee_Display','true');
                setCheckbox('#adminFeeHorsePage',excludeAdminFee);

            }

        },
    });
}

export function showKeepRateEdit(options) {

    if (!options){
        options = {};
    }

    if (!options.source) {
        options.source = 'Settings';
    }

    if (!options.ids) {
        options.ids = 'new';
    }

    var popURL = '/pages/pop/setting/keepRateEdit.cfm?'
            + jQuery.param({
                source: options.source,
                ids: options.ids,
            });

    popWin({
        title: 'Keep Category',
        popID: 'keepRateEdit',
        noAutoWidth: true,
        page: popURL,
        width: 600,
        height: 480,
        modal: true,
    });

}

export function init(options) {
    if (!options) {
        options = {};
    }
    $('.jq_button').button();
}